import {toggleMark} from "prosemirror-commands";

export default class AbstractMark {
    get type() {
        return "mark";
    }

    get schema() {
        return {}
    }

    get markdownToken() {
        return "";
    }

    get toMarkdown() {
        return {};
    }

    get parseMarkdown() {
        return {};
    }

    inputRules({type}) {
        return [];
    }

    keys(type) {
        return {}
    }

    commands({type}) {
        return () => toggleMark(type);
    }
}